import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromUserProfile from '../../user-profile.reducer';
import { ApplicationStatusEnums } from '../../enums/common.enum';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { toTitleCase } from '../../../../utils/common.utils';
import { Subject, takeUntil } from 'rxjs';
import { SIDEBAR_TABS } from '@shared/constants/tab-approval.constant';
import { ShowTabByApprovalPipe } from '@shared/pipes/show-tab-by-approval.pipe';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  userProfile;
  applicationStatusEnums = ApplicationStatusEnums;
  isCreator = false;
  delegateContent = '';
  destroy$ = new Subject<void>();

  constructor(
    private readonly store: Store<fromUserProfile.UserProfileState>,
    private readonly router: Router,
    public readonly cs: CommonService,
    private showTabByApproval: ShowTabByApprovalPipe
  ) {}

  ngOnInit(): void {
      this.userProfile = {};
      this.getProfile();
  }

  getProfile() {
    this.store
      .select(fromUserProfile.getUserProfileItems)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.userProfile = res;
        const delLength = this.userProfile?.delegate_user?.type?.length;
        if (delLength) {
          this.userProfile.delegate_user.type =
            this.userProfile.delegate_user.type.map((item) => {
              return toTitleCase(item);
            });
          this.delegateContent =
            delLength > 1
              ? this.userProfile.delegate_user.type.join(', ').trim()
              : this.userProfile.delegate_user.type[0];
        }
        this.userProfile = {
          ...this.userProfile,
          displayed_name: res.user_name
          ?.split('_')
          ?.join(' ')
          ?.trim()
        }
        this.isCreator = res?.is_creator;
      });
  }

  navigateToProfile() {
    if(!this.showTabByApproval.transform(this.userProfile, SIDEBAR_TABS.PROFILE_NAV)) return;
    if (this.isCreator) {
      this.router.navigate(['/' + this.userProfile?.user_name]);
    } else if (this.userProfile?.refer_id) {
      this.router.navigate(['/' + this.userProfile?.refer_id]);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
